import { createSelector } from 'reselect';
import hasIn from 'transmute/hasIn';
import memoize from 'transmute/memoize';
import * as LocalStorageKeys from 'automation-ui-canvas/constants/LocalStorageKeys';
import { getPortalId, getHubSpotUserId } from 'automation-ui-canvas/selectors/authSelectors';
const getLocalStorage = state => state.localStorage;
export const isMinimapMinimized = createSelector([getLocalStorage, getPortalId, getHubSpotUserId], (storage, portalId, userId) => {
  const localStorageValue = storage.get(`${LocalStorageKeys.MINIMAP_MINIMIZED}-${portalId}-${userId}`);

  // if the user never minimized, default to true
  if (localStorageValue === undefined) {
    return true;
  }
  return localStorageValue;
});
export const isWaitUntilOnboardingDismissed = createSelector([getLocalStorage, getPortalId, getHubSpotUserId], (storage, portalId, userId) => hasIn([LocalStorageKeys.ONBOARDING_FOR_WAIT_UNTIL, portalId, userId], storage));
export const getIsCustomFormulaOnboardingDismissed = createSelector([getLocalStorage, getPortalId], (storage, portalId) => {
  return hasIn([LocalStorageKeys.ONBOARDING_CUSTOM_FORMULA, `${portalId}`], storage);
});
export const getPreviouslyTestedObjectId = createSelector([getLocalStorage, getPortalId], (storage, portalId) => {
  const localStorageValue = storage.get(`${LocalStorageKeys.PREVIOUSLY_TESTED_OBJECT_ID}-${portalId}`);
  return localStorageValue ? {
    objectId: Number(localStorageValue.get('objectId')),
    objectTypeId: localStorageValue.get('objectTypeId') || ''
  } : null;
});
export const getZoomLevel = memoize(flowId => createSelector([getLocalStorage, getPortalId], (storage, portalId) => {
  const localStorageValue = storage.get(`${LocalStorageKeys.ZOOM_LEVEL}-${portalId}-${flowId}`);
  return localStorageValue || 1;
}));